import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BOOKING_URL } from "@/components/Nav";
import { API } from "@/App";

const SALON_FB = {
  name: "SALON ORGÆNICS",
  tagline: "Pure. Natural. Timeless.",
  address: "Salon Orgaenics, VJ Yashwin Orrizonte, near Panchshil Towers, Kharadi, Pune 411014",
  phone: "+91 91580 00424",
  phone_raw: "919158000424",
  email: "admin.saloneur@gmail.com",
  hours: "Open daily · 11:00 AM – 10:00 PM",
};

export default function Footer() {
  const [salon, setSalon] = useState(SALON_FB);
  useEffect(() => {
    axios
      .get(`${API}/salon`)
      .then((r) => setSalon({ ...SALON_FB, ...r.data }))
      .catch(() => {});
  }, []);
  return (
    <footer className="relative bg-[#11261A] text-[#F9FAF8] grain overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-8 relative z-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo-emblem-light.png" alt="Salon Orgænics emblem" className="w-10 h-10 object-contain" />
              <span className="font-display text-2xl tracking-[0.18em] font-medium">SALON ORGÆNICS</span>
            </div>
            <p className="font-display italic font-light text-xl text-[#8EA696] mb-8">Pure. Natural. Timeless.</p>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-now-button"
              className="inline-block rounded-full border border-[#8EA696]/50 text-[12px] uppercase tracking-[0.22em] px-8 py-3 transition-all duration-300 hover:bg-[#F9FAF8] hover:text-[#11261A] hover:border-[#F9FAF8]"
            >
              Reserve your chair
            </a>
          </div>

          <div className="md:col-span-4 space-y-4 text-sm text-[#F9FAF8]/80">
            <p className="flex gap-3 items-start">
              <MapPin size={16} className="mt-0.5 shrink-0 text-[#8EA696]" />
              <span>{salon.address}</span>
            </p>
            <p className="flex gap-3 items-center">
              <Clock size={16} className="shrink-0 text-[#8EA696]" />
              <span>{salon.hours}</span>
            </p>
            <a href={`tel:+${salon.phone_raw}`} data-testid="footer-phone-link" className="flex gap-3 items-center hover:text-white transition-colors">
              <Phone size={16} className="shrink-0 text-[#8EA696]" />
              <span>{salon.phone}</span>
            </a>
            <a href={`mailto:${salon.email}`} data-testid="footer-email-link" className="flex gap-3 items-center hover:text-white transition-colors">
              <Mail size={16} className="shrink-0 text-[#8EA696]" />
              <span>{salon.email}</span>
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.35em] text-[#8EA696] mb-6">Explore</p>
            <div className="flex flex-col gap-3 text-sm">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Services & Menu", "/services"],
                ["Contact", "/contact"],
                ["Terms & Conditions", "/terms"],
                ["Privacy Policy", "/privacy"],
                ["Refund Policy", "/refund"],
              ].map(([label, to]) => (
                <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-[#F9FAF8]/80 hover:text-white transition-colors w-fit">
                  {label}
                </Link>
              ))}
              <a
                href="https://www.instagram.com/salonorgaenics"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="text-[#F9FAF8]/80 hover:text-white transition-colors w-fit"
              >
                Instagram
              </a>
              <a
                href="https://share.google/loQbX71kZILHwidN1"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-google-business-link"
                className="text-[#F9FAF8]/80 hover:text-white transition-colors w-fit"
              >
                Google Business Profile
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#1B3B28] flex flex-col md:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-[#8EA696]">
          <p>© {new Date().getFullYear()} Salon Orgænics</p>
          <p>Where your hair is cared for, not just styled</p>
        </div>
      </div>
    </footer>
  );
}
